import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_EMAREGULATION,
  DELETE_EMAREGULATION,
  GET_EMAREGULATIONS,
  UPDATE_EMAREGULATION,
  UPDATE_EMAREGULATION_STATUS
} from "./actionTypes";

import {
  addEmaRegulationFail,
  addEmaRegulationSuccess,
  deleteEmaRegulationFail,
  deleteEmaRegulationSuccess,
  getEmaRegulationsFail,
  getEmaRegulationsSuccess,
  setState,
  updateEmaRegulationFail,
  updateEmaRegulationSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { emaRegulations, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchEmaRegulations({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, emaRegulations, params.toString());
    yield put(setState(false));
    yield put(getEmaRegulationsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getEmaRegulationsFail(error));
  }
}

function* updateEmaRegulation({ payload: emaRegulationObj }) {
  try {
    const { id, recordStatus, ...rest } = emaRegulationObj;
    yield call(patchApiCall, `${emaRegulations}/${id}`, rest);
    const response = yield call(getTable, `${emaRegulations}/${emaRegulationObj.id}`);
    toast.success('Registro actualizado correctamente');
    yield put(updateEmaRegulationSuccess(response));
  } catch (error) {
    toast.error('Error al actualizar el registro');
    yield put(updateEmaRegulationFail(error));
  }
}

function* updateEmaRegulationStatus({ payload: emaRegulationObj }) {
  try {
    const { id } = emaRegulationObj;
    yield call(patchApiCall, `${emaRegulations}/${updateStatus}/${id}`, { recordStatus: emaRegulationObj.recordStatus });
    const response = yield call(getTable, `${emaRegulations}/${emaRegulationObj.id}`);
    yield put(updateEmaRegulationSuccess(response));
  } catch (error) {
    yield put(updateEmaRegulationFail(error));
  }
}

function* deleteEmaRegulation({ payload: emaRegulationObj }) {
  try {
    yield call(deleteApiCall, `${emaRegulations}/${emaRegulationObj.id}`);
    yield put(deleteEmaRegulationSuccess(emaRegulationObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    toast.error('Error al borrar el registro');
    yield put(deleteEmaRegulationFail(error));
  }
}

function* postingEmaRegulation({ payload: emaRegulation }) {
  try {
    const response = yield call(postApiCall, emaRegulations, emaRegulation);
    yield put(addEmaRegulationSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    toast.error('Error al agregar el registro');
    yield put(addEmaRegulationFail(error));
  }
}

function* emaRegulationsSaga() {
  yield takeEvery(GET_EMAREGULATIONS, fetchEmaRegulations);
  yield takeEvery(ADD_NEW_EMAREGULATION, postingEmaRegulation);
  yield takeEvery(UPDATE_EMAREGULATION, updateEmaRegulation);
  yield takeEvery(UPDATE_EMAREGULATION_STATUS, updateEmaRegulationStatus);
  yield takeEvery(DELETE_EMAREGULATION, deleteEmaRegulation);
}

export default emaRegulationsSaga;
